import LazyLoad from "vanilla-lazyload";

declare global {
  interface Window {
    lazyFunctions: { [key: string]: (element: HTMLElement) => void };
    lazyload: typeof LazyLoad;
  }
}

window.lazyFunctions = {
  replacePoster: (element) => {
    const posterSrc = element.getAttribute("data-poster-src");
    if (posterSrc) {
      element.setAttribute("poster", posterSrc);
    }
  },
};

const executeLazyFunction = (element) => {
  const lazyFunctionName = element.getAttribute("data-lazy-function");
  const lazyFunction = window.lazyFunctions[lazyFunctionName];
  if (!lazyFunction) return;
  lazyFunction(element);
};

window.lazyload = new (LazyLoad as any)({
  callback_enter: executeLazyFunction,
  unobserve_entered: true,
  elements_selector: ".lazy",
  // threshold: 300,
});

document.addEventListener("turbo:load", () => {
  (window.lazyload as any).update();
});

document.addEventListener("turbo:frame-load", () => {
  (window.lazyload as any).update();
});
